import { isConfigFlagEnabled } from '../../config';
import { setAutoReconnectSessionUuid } from '../../utils/autoReconnectUtils';
/**
 * Actions for state to be tracked across an entire session (state is not reset between scenes for example).
 */
export const SET_TEMP_LOGIN_CREDENTIALS = 'SET_TEMP_LOGIN_CREDENTIALS';
export const SET_MOBILE_WARNING_MODAL_AS_SHOWN = 'SET_MOBILE_WARNING_MODAL_AS_SHOWN';
export const SET_CONNECTION_IS_LOST = 'SET_CONNECTION_IS_LOST';
export const SET_LOADING_IS_DONE = 'SET_LOADING_IS_DONE';
export const DISABLE_BEFORE_UNLOAD = 'DISABLE_BEFORE_UNLOAD';
export const TOGGLE_EXPANDABLE_SECTION = 'TOGGLE_EXPANDABLE_SECTION';
export const TOGGLE_IS_HI_DPI_ALLOWED = 'TOGGLE_IS_HI_DPI_ALLOWED';
export const CHANGE_NUM_BOMBS_TO_THROW = 'CHANGE_NUM_BOMBS_TO_THROW';
export const SET_APP_DIMENSIONS = 'SET_APP_DIMENSIONS';
export const ENSURE_PANEL_HAS_PRIORITY = 'ENSURE_PANEL_HAS_PRIORITY';
export const SET_BAD_BEAT_JACKPOT_AMOUNT_FROM_INBOUND = 'SET_BAD_BEAT_JACKPOT_AMOUNT_FROM_INBOUND';
export const SET_IS_CLIENT_VERSION_OK = 'SET_IS_CLIENT_VERSION_OK';
export const SET_BOMB_LOADED = 'SET_BOMB_LOADED';
export const SET_SESSION_ID_FROM_INBOUND = 'SET_SESSION_ID_FROM_INBOUND';
export function setTempLoginCredentials(loginCredentials) {
    return {
        type: SET_TEMP_LOGIN_CREDENTIALS,
        payload: loginCredentials
    };
}
export function setMobileWarningModalAsShown() {
    return {
        type: SET_MOBILE_WARNING_MODAL_AS_SHOWN
    };
}
export function setConnectionIsLost() {
    return {
        type: SET_CONNECTION_IS_LOST
    };
}
export function setLoadingIsDone() {
    return {
        type: SET_LOADING_IS_DONE
    };
}
export function disableBeforeUnload() {
    return {
        type: DISABLE_BEFORE_UNLOAD
    };
}
export function toggleExpandableSection(expandableSection) {
    return {
        type: TOGGLE_EXPANDABLE_SECTION,
        payload: expandableSection
    };
}
export function toggleIsHiDpiAllowed() {
    return {
        type: TOGGLE_IS_HI_DPI_ALLOWED
    };
}
export function changeNumBombsToThrow() {
    return {
        type: CHANGE_NUM_BOMBS_TO_THROW
    };
}
export function setAppDimensions(dimensions) {
    return {
        type: SET_APP_DIMENSIONS,
        payload: dimensions
    };
}
export function ensurePanelHasPriority(panelType, numEnabledPanels, numVisiblePanelButtons) {
    return {
        type: ENSURE_PANEL_HAS_PRIORITY,
        payload: { panelType, numEnabledPanels, numVisiblePanelButtons }
    };
}
export function setBadBeatJackpotAmountFromInbound(inbound) {
    return {
        type: SET_BAD_BEAT_JACKPOT_AMOUNT_FROM_INBOUND,
        payload: inbound
    };
}
export function setIsClientVersionOk(isClientVersionOk) {
    return {
        type: SET_IS_CLIENT_VERSION_OK,
        payload: isClientVersionOk
    };
}
export function setBombLoaded(bombType) {
    return {
        type: SET_BOMB_LOADED,
        payload: bombType
    };
}
function setSessionIdFromInbound(inbound) {
    return {
        type: SET_SESSION_ID_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkSetSessionIdFromInbound(inbound) {
    return function (dispatch) {
        if (inbound.sessionUuid && isConfigFlagEnabled('autoReconnect')) {
            setAutoReconnectSessionUuid(inbound.sessionUuid);
        }
        dispatch(setSessionIdFromInbound(inbound));
    };
}
